import { StandardTask } from '@seen/core/models/tasks/standard/standardTask'
import type { ReactNode } from 'react'
import { useParams } from 'react-router'
import { PageLayout } from '#src/components/display/PageLayout.tsx'
import { useRead } from '#src/hooks/useRead.ts'
import { TaskPageContent } from '#src/pages/task/TaskPageContent.tsx'

export function TaskPage(): ReactNode {
  const { taskId } = useParams()
  const { data: task } = useRead(StandardTask, taskId)

  if (!task) {
    return null
  }

  return (
    <PageLayout contentClassName="mx-auto w-full max-w-[calc(76ch+3rem)]">
      <TaskPageContent task={task} />
    </PageLayout>
  )
}
